import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=3f9b3d12&scoped=true&"
import script from "@/views/Permissions/Permissions.ts?vue&type=script&lang=ts&"
export * from "@/views/Permissions/Permissions.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Permissions/Permissions.scss?vue&type=style&index=0&id=3f9b3d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9b3d12",
  null
  
)

export default component.exports